import React, { Component } from 'react';
import css from './Footer.module.scss';

export default class Footer extends Component {
  state = {
  }

  render () {
      return (
        <footer className={css.footer} id="contact">
          <p className={css.footerText}>Projects, advice, restaurant recommendations?<br />My inbox is open</p>
          <a href="mailto:df@derekfidler.com" className={css.contactButton}>Contact Me <span className={css.hand}></span></a>
          <div className={css.footerMeta}>
            <ul className={css.footerLinks}>
              <li>
                <a
                  href="https://dribbble.com/derekfidler"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={css.dribbble}>
                  Dribbble</a>
              </li>
              <li>
                <a
                  href="https://twitter.com/derekfidler"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={css.twitter}
                  >Twitter</a>
              </li>
              <li>
                <a
                  href="https://medium.com/@derekfidler"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={css.medium}
                  >Medium</a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/in/derekfidler/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={css.linkedin}
                  >LinkedIn</a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/dwinstonfidler"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={css.facebook}
                  >Facebook</a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/dwfidler/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={css.instagram}
                  >Instagram</a>
              </li>
              <li>
                <a
                href="https://www.youtube.com/channel/UCe8YhGZabsde2GzeRfEWIMA"
                target="_blank"
                rel="noopener noreferrer"
                className={css.youtube}
                >YouTube</a>
              </li>
            </ul>
            <p className={css.copyright}>
              Copyright ©2021
            </p>
          </div>
        </footer>
      )
   }
}
